import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MyPromise } from '../../interceptors/myPromise.service';

const PROCEDURES_API = `${environment.baseEndpoint}/procedures`;
const FILES_API = `${environment.baseEndpoint}/fileGenerator`;

@Injectable({
  providedIn: 'root',
})
export class ProcedureOneService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) { }

  getPolicy(stationId) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.get(`${PROCEDURES_API}/${stationId}/1/signPolitics`));
  }

  signPolicy(stationId, signPolicy) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/1/signPolitics`, signPolicy));
  }

  updateSignPolicy(stationId, signPolicy) {
    // tslint:disable-next-line: max-line-length
    return this.myPromise.to(this.http.post(`${PROCEDURES_API}/${stationId}/1/signPolitics`, signPolicy));
  }

  downloadPolitics(stationId: string) {
    return this.myPromise.to(this.http.get(`${FILES_API}?documentType=sasisopaImplementation&stationId=${stationId}&procedure=1&document=politics`));
  }
}
